export enum OrderActivityType {
  ORDER_ACCEPTED = 'ORDER_ACCEPTED',
  ORDER_PROCESSING = 'ORDER_PROCESSING',
  ORDER_CREATED = 'ORDER_CREATED',
  ORDER_CANCELLED = 'ORDER_CANCELLED',
  ORDER_CONFIRMED = 'ORDER_CONFIRMED',
  ORDER_MODIFICATION_ACCEPTED = 'ORDER_MODIFICATION_ACCEPTED',
  ORDER_MODIFICATION_CREATED = 'ORDER_MODIFICATION_CREATED',
  ORDER_MODIFICATION_PROCESSING = 'ORDER_MODIFICATION_PROCESSING',
  ORDER_MODIFICATION_ACCEPTED_WITH_CONSULT = 'ORDER_MODIFICATION_ACCEPTED_WITH_CONSULT',
  ORDER_MODIFICATION_REJECTED = 'ORDER_MODIFICATION_REJECTED',
  ORDER_PLUS_LOAD_CREATED = 'ORDER_PLUS_LOAD_CREATED',
  ORDER_PLUS_LOAD_APPLIED = 'ORDER_PLUS_LOAD_APPLIED',
  ORDER_PLUS_LOAD_REJECTED = 'ORDER_PLUS_LOAD_REJECTED',
}
